import { useState, useEffect, useCallback } from 'react';
import fleetApi from '../../services/api.service';

export default function useGetPhoneNumbers() {
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPhoneNumbers = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fleetApi.get('/clients/phone-numbers/management');
      setPhoneNumbers(response.data.phone_numbers || []);
    } catch (err) {
      setError(
        err.message ||
          'Une erreur est survenue lors de la récupération des numéros de téléphone'
      );
      setPhoneNumbers([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPhoneNumbers();
  }, [fetchPhoneNumbers]);

  const refetch = useCallback(() => {
    fetchPhoneNumbers();
  }, [fetchPhoneNumbers]);

  return {
    phoneNumbers,
    isLoading,
    error,
    refetch,
  };
}
